import {
  Stack,
  useTheme,
  Typography,
  Box,
  Button,
  styled,
} from "@mui/material";
import React from "react";
import Image from "../../image/image";
import { useNavigate } from "react-router-dom";
import { PaymentWalletButton } from "../../ButtonWalletPay";
import { formatMoney } from "../../../lib/formatMoney";
import ShareButton from "../../ShareLink";
import PropertyShareButton from "../../ShareButton";

const PossibilitiesItem = ({
  id,
  slug,
  img,
  name,
  description,
  isSoo,
  city,
  isNormal,
  isTokenize,
  isIDO,
  price,
  priceMxn,
  priceSoil,
  saleStage,
  sponsor,
}) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/propiedades/${slug}`, {});
    window.scrollTo(0, 0);
  };
  const theme = useTheme();
  const borderValue = `1px solid ${theme.palette.divider}`;
  return (
    <Stack
      border={borderValue}
      p={{ xs: "20px", md: "8px", xl: "15px" }}
      direction="column"
      key={slug}
      mx={{ xs: "0", md: 2 }}
      borderRadius="10px"
      sx={{
        width: { xs: "100%", md: "325px", xl: "350px" },
        maxWidth: "90%",
        minHeight: { xs: "507px", md: "416px", xl: "480px" },
      }}
    >
      <Stack>
        <Image src={img} ratio="6/4" />

        {/*  <StyledBox>
          <Typography variant="body2" color="text.secondary">
            {"nameOfResidence"}
          </Typography>
        </StyledBox> */}
      </Stack>
      <Stack direction="column">
        {/* <PropertyShareButton /> */}
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="subtitle1"
            color="text.secondary"
            pt={2}
            textTransform={"capitalize"}
            fontWeight={"bold"}
          >
            {name}
          </Typography>
          <PropertyShareButton
            propertyTitle={name}
            propertyPrice={price}
            propertyLocation={city}
            propertyUrl={`https://share-estate.plusvalica.com/share/${slug}${
              !!sponsor ? `?p=${sponsor}` : ""
            }`}
          />
        </Stack>
        {/* <Typography
          variant="subtitle1"
          color="text.secondary"
          pt={2}
          textTransform={"capitalize"}
          fontWeight={"bold"}
        >
          {name}
        </Typography> */}
        <Typography
          variant="subtitle1"
          color="text.secondary"
          textTransform={"capitalize"}
          fontSize={"0.9rem"}
        >
          {city}
        </Typography>
        {/*  {!!description && (

          <Typography variant="subtitle1" color="text.primary" mb={2}>
            {description.length === 0 ? "" : description.slice(0, 200) + "..."}
          </Typography>
        )}{" "} */}
      </Stack>
      <Stack>
        {isNormal && (
          <Stack
            direction="row"
            justifyContent="space-between"
            marginBottom={2}
          >
            {!isSoo && (
              <Stack direction="column">
                <Typography variant="caption" color="text.primary">
                  Precios
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {price}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {priceMxn}
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  {priceSoil}
                </Typography>
              </Stack>
            )}
          </Stack>
        )}
        {["ACTIVE", "COMPLETED"].includes(isTokenize) && (
          <Stack direction="column">
            <Stack
              direction="row"
              justifyContent="space-between"
              marginBottom={2}
            >
              {saleStage.length === 1 && !isSoo && (
                <Stack direction="column">
                  <Typography variant="caption" color="text.primary">
                    Precio
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    ${" "}
                    {formatMoney({
                      amount: Number(saleStage[0].pricePerToken),
                      symbol: " USD",
                    })}
                  </Typography>
                </Stack>
              )}
              <Stack direction="column">
                <Typography variant="caption" color="text.primary">
                  Tipo
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  Tokenizacion
                </Typography>
              </Stack>
            </Stack>
            {saleStage.length === 1 && (
              <Stack
                direction="row"
                justifyContent="space-between"
                marginBottom={2}
              >
                <Stack direction="column">
                  <Typography variant="caption" color="text.primary">
                    Etapa
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {saleStage[0].stageOrder}
                  </Typography>
                </Stack>
                <Stack direction="column">
                  <Typography variant="caption" color="text.primary">
                    Tokens a vender
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {formatMoney({
                      amount: Number(saleStage[0].totalTokens),
                      decimals: 0,
                      symbol: "",
                    })}
                  </Typography>
                </Stack>
              </Stack>
            )}
          </Stack>
        )}
        {["ACTIVE", "COMPLETED"].includes(isIDO) && (
          <Stack direction="column">
            <Stack
              direction="row"
              justifyContent="space-between"
              marginBottom={2}
            >
              {saleStage.length === 1 && (
                <Stack direction="column">
                  <Typography variant="caption" color="text.primary">
                    Precio
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {formatMoney({
                      amount: Number(saleStage[0].pricePerToken),
                      symbol: " USD",
                    })}
                  </Typography>
                </Stack>
              )}
              <Stack direction="column">
                <Typography variant="caption" color="text.primary">
                  Tipo
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  IDO
                </Typography>
              </Stack>
            </Stack>
            {saleStage.length === 1 && (
              <Stack
                direction="row"
                justifyContent="space-between"
                marginBottom={2}
              >
                <Stack direction="column">
                  <Typography variant="caption" color="text.primary">
                    Etapa
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {saleStage[0].stageOrder}
                  </Typography>
                </Stack>
                <Stack direction="column">
                  <Typography variant="caption" color="text.primary">
                    Tokens a vender
                  </Typography>
                  <Typography variant="subtitle1" color="text.secondary">
                    {formatMoney({
                      amount: Number(saleStage[0].totalTokens),
                      decimals: 0,
                      symbol: "",
                    })}
                  </Typography>
                </Stack>
              </Stack>
            )}
          </Stack>
        )}
      </Stack>
      <Stack direction="column" gap={1.5}>
        {!isSoo && (
          <Button
            variant="outlined"
            onClick={handleClick}
            sx={{
              borderColor: "#a95052",
              color: "white",
              paddingX: { md: "5px", xl: "20px" },
              backgroundColor: "transparent",
              lineHeight: { md: "1.2", xl: "1.75" },
              "&:hover": {
                backgroundColor: "#a95052",
                color: "white",
                borderColor: "#a95052",
              },
              transition: "background-color 0.3s ease, color 0.3s ease",
            }}
          >
            Ver detalles de la propiedad
          </Button>
        )}

        {!isSoo && !isNormal && saleStage.length === 1 && (
          <PaymentWalletButton
            propertyId={id}
            onPaymentSuccess={() => {
              console.log("pago completado");
            }}
            onWindowClosed={() => {
              console.log("ventana cerrada");
            }}
          >
            Comprar
          </PaymentWalletButton>
        )}
      </Stack>
    </Stack>
  );
};

export default PossibilitiesItem;
